import React from 'react';
import Grid from '@material-ui/core/Grid';
import { AppBar, Toolbar } from '@material-ui/core';
import rokitlogo from '../asset/rokitlogo.png';
import aidlogo from '../asset/aidlogo.png';
import { Image } from 'react-bootstrap';

const Footer = () => {
  return (
    <div
    style={{
      marginTop: '20px',
    }}
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-end"
      >
        <AppBar
          position="static"
          color="primary"
          style={{ backgroundColor: 'rgb(63, 89, 140)' }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Toolbar>
              <a
                href="https://aidregen.com"
                target="_blank"
                className="footer-logo"
              >
                <Image src={aidlogo} style={{ marginRight: 20 }}></Image>
              </a>
              <a
                href="https://rokithealthcare.com"
                target="_blank"
                className="footer-logo"
              >
                <Image src={rokitlogo}></Image>
              </a>
            </Toolbar>
          </Grid>
        </AppBar>
      </Grid>
    </div>
  );
};

export default Footer;
